import api from "./api";

// « Value du jour » foot : un seul chargement partagé entre la barre du bas et la page /value
// (demande en cours ou réponse de moins de 10 s réutilisée).
const REUSE_MS = 10000;
let shared = null;

export function loadValueOfDay() {
  const now = Date.now();
  if (shared && now - shared.at < REUSE_MS) return shared.promise;
  const promise = api.get("/value-of-the-day").then((r) => r.data);
  shared = { at: now, promise };
  promise.catch(() => { if (shared && shared.promise === promise) shared = null; });
  return promise;
}

export function resetValueOfDay() {
  shared = null;
}
